// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"24":"4ceecd55","141":"b61b3ef0","151":"b9ac70c8","213":"57177014","437":"b97e23fd","474":"f495ec78","475":"b14a7875","835":"f8ae3707","897":"1740f6fe","979":"83348b2a"}[chunkId] + ".js";
};